import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import AdSenseLoader from "./components/AdSenseLoader";

import Layout from "./components/Layout/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import TraditionalLogin from "./pages/TraditionalLogin";
import BlogPost from "./pages/BlogPost";
import BlogListPage from "./pages/BlogListPage";
import NewsDetail from "./pages/NewsDetail";
import Admin from "./pages/Admin";
import AdminRoute from "./components/AdminRoute";
import CategoryPage from "./pages/CategoryPage";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import { Container, Typography } from "@mui/material";

const GOOGLE_CLIENT_ID = "742192042042-9b1bs22s17brrimeajboctqfkld1g1ai.apps.googleusercontent.com";





function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeContextProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          {/* <AdSenseLoader /> */}
          <Routes>
            {/* Rutas públicas */}
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            <Route
              path="/login"
              element={
                <Layout>
                  <TraditionalLogin />
                </Layout>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <Layout>
                  <ForgotPassword />
                </Layout>
              }
            />
            <Route
              path="/reset-password/:uid/:token"
              element={
                <Layout>
                  <ForgotPassword />
                </Layout>
              }
            />
            <Route
              path="/profile"
              element={
                <Layout>
                  <Profile />
                </Layout>
              }
            />
            <Route
              path="/blog"
              element={
                <Layout>
                  <BlogListPage />
                </Layout>
              }
            />
            <Route
              path="/blog/:slug"
              element={
                <Layout>
                  <BlogPost />
                </Layout>
              }
            />
            <Route
              path="/news/:id"
              element={
                <Layout>
                  <NewsDetail />
                </Layout>
              }
            />
            <Route
              path="/category/:slug"
              element={
                <Layout>
                  <CategoryPage />
                </Layout>
              }
            />

            {/* Ruta admin - usa el componente Admin directamente */}
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
          </Routes>
        </Router>
      </ThemeContextProvider>
    </GoogleOAuthProvider>
  );
}

export default App;